<template>
  <div class="sf-bot-bubble" aria-live="polite">
    <div v-if="question" class="sf-bot-bubble__tag">{{ question.label }}</div>
    <div class="sf-bot-bubble__text">
      <span v-if="text">{{ text }}</span>
      <span v-else-if="question">{{ question.prompt }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BotBubble',

  props: {
    text: { type: String, default: null },
    question: { type: Object, default: null },
  },
};
</script>

<style lang="scss" scoped>
.sf-bot-bubble {
  align-self: flex-start;
  max-width: 280px;
  animation: sf-msg-appear 0.25s cubic-bezier(0.16, 1, 0.3, 1) both;

  &__tag {
    display: inline-block;
    background: #e5bb5f;
    color: #23201e;
    font-size: 12px;
    font-weight: 700;
    padding: 2px 10px;
    border-radius: 10px 10px 0 0;
    margin-bottom: 0;
    font-family: 'Comfortaa', sans-serif;
  }

  &__text {
    background: #fff;
    border-radius: 0 10px 10px 10px;
    padding: 12px 16px;
    font-size: 15px;
    color: #23201e;
    font-family: 'Comfortaa', sans-serif;
    line-height: 1.5;

    .sf-bot-bubble__tag + & {
      border-radius: 0 10px 10px 10px;
    }
  }
}

@keyframes sf-msg-appear {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
